<template>
	<div class="news_info">
		<!-- 公共头 start -->
		<Header></Header>
		<!-- 公共头 end -->

		<!-- 面包屑 start -->
		<div class="crumb container" v-if="id">
			当前位置：
			<a @click="toPage('/')" class="cp" target="_parent">首页</a>
			&nbsp;&gt;&nbsp;
			<a @click="toPage('/news_list?category=' + menuInfo.id)" class="cp" target="_parent">{{ menuInfo.name }}</a>
			&nbsp;&gt;&nbsp;
			<a target="_parent">资讯详情</a>
		</div>
		<!-- 面包屑 end -->

		<div class="container bg-white padd m-mt20">
			<div class="details">
				<div class="channel">
					<p class="channelName">{{ menuInfo.name }}</p>
					<a @click="toPage('/news_list?category=' + menuInfo.id)" class="backList cp">返回{{ menuInfo.name }}</a>
				</div>
				<div class="content_detail">
					<h3 class="title">{{ newsInfo.title }}</h3>
					<p class="pubtime">发布时间：{{ newsInfo.publishTime }}</p>
					<div class="contents" v-html="newsInfo.content"></div>
				</div>
			</div>
		</div>

		<!-- 公共尾 start -->
		<Footer></Footer>
		<!-- 公共尾 end -->
	</div>
</template>

<script>
import Header from '@/components/header';
import Footer from '@/components/footer';
export default {
	components: {
		Header,
		Footer
	},
	name: 'Index',
	data() {
		return {
			menuInfo: {},
			id: null,
			newsInfo: {},
			title: '',
			keywords: '',
			description: ''
		};
	},
	metaInfo() {
		return {
			title: this.pageTitle,
			meta: [
				{
					name: 'description',
					content: this.pageKeywords
				},
				{
					name: 'keywords',
					content: this.pageDescription
				}
			]
		};
	},
	watch: {
		$route: function() {
			this.id = this.$route.query.id;
			this.getNewsInfo();
		}
	},
	computed: {
		pageTitle() {
			return this.title;
		},
		pageKeywords() {
			return this.keywords;
		},
		pageDescription() {
			return this.description;
		}
	},
	mounted() {
		this.id = this.$route.query.id;
		this.getNewsInfo();
	},
	methods: {
		getNewsInfo() {
			this.req({
				url: '/system/news/' + this.id,
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					this.newsInfo = res.data;
					this.title = res.data.seoTitle;
					this.keywords = res.data.seoKeywords;
					this.description = res.data.seoDescription;
					this.getMenuInfo(res.data.category);
				}
			});
		},
		// 获取菜单详情
		getMenuInfo(ids) {
			this.req({
				url: '/system/menus/' + ids,
				params: {},
				method: 'get'
			}).then(res => {
				// console.log(res);
				if (res.code == 200) {
					// this.menuList = res.rows;
					console.log(res);
					if (res.data.parentId == 0) {
						this.menuInfo = res.data;
					}
				}
			});
		},
		toPage(path) {
			this.$router.push(path);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped src="../assets/news_info/common.css"></style>
<style scoped src="../assets/news_info/details.css"></style>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/pages/news_info.vue